import React, { useState } from "react";
import Modal from "react-modal";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import CommonStructured from "../../common-components/CommonStructured";
import AddKeywordsForm from "./AddKeywordsForm";

const AddKeyword = ({ decryptedText, callKeyFunction }) => {
  const [keywordFormModal, setKeywordFormModal] = useState(false);

  const onCloseModal = () => {
    setKeywordFormModal(false);
  };

  return (
    <>
      <Modal
        isOpen={keywordFormModal}
        onRequestClose={onCloseModal}
        contentLabel="Wati Keywords Modal"
        ariaHideApp={false}
      >
        <div className="createNewCTOModalContainer mod-width-50p">
          <ModalHeadAndClose title="Wati Keywords" onClose={onCloseModal} />

          <AddKeywordsForm
            decryptedText={decryptedText}
            callKeyFunction={callKeyFunction}
            onCloseModal={onCloseModal}
          />
        </div>
      </Modal>

      <CommonStructured
        pageHeading={"Wati Keywords"}
        createBtnTxt={"+ Add New Keyword"}
        onClickCreateBtn={() => setKeywordFormModal(true)}
        isReload={callKeyFunction}
      />
    </>
  );
};

export default AddKeyword;
